<template>
    <div class="pdetail_box">
        <bread-crumb></bread-crumb>
        <!-- 上半部分 -->
        <div class="pdetail_top">
            <div class="container">
                <el-row>
                    <el-col :lg="9" :sm="11" :xs="11">
                        <pdetail-imgs></pdetail-imgs>
                    </el-col>
                    <el-col :lg="14" :sm="13" :xs="13">
                        <pdetail-text></pdetail-text>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 下半部分 -->
        <pdetail-tabs></pdetail-tabs>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
    props: {
        cate_id:{
            default: false
        }
    },
    computed: {
        bc_id(){
            if(this.cate_id){
                localStorage.bc_id = this.cate_id;
                return this.cate_id
            }else if (localStorage.bc_id){
                return localStorage.bc_id
            }else{
                return this.$store.state.goods.goods.cat_id
            }
        }
    },
    components: {
        breadCrumb: () => import("@/components/breadCrumb"),
        pdetailImgs: () => import("@/components/pdetailImgs"),
        pdetailText: () => import("@/components/pdetailText"),
        pdetailTabs: () => import("@/components/pdetailTabs")
    },
    methods: {
        ...mapMutations([
            "clearPdetail",
        ]),
        ...mapActions([
            "getBreadCrumb",
            "getPdetail"
        ])
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            vm.getBreadCrumb(vm.bc_id)
            let { id } = to.query;
            vm.getPdetail(id);
        })
    },
    beforeRouteLeave (to, from, next) {
        this.clearPdetail();
        localStorage.removeItem('bc_id')
        next();
    }
}
</script>

<style scoped>
.pdetail_top{
    padding: 50px 0;
    background: #fff;
}
</style>
